import { useQuery } from '@tanstack/react-query';
import { getOrgUsersCount } from 'src/api/orgs';
import { useCurrentUser } from 'src/hooks';

export const useGetOrgUsersCount = () => {
  const { user } = useCurrentUser();

  return useQuery({
    queryKey: ['org-users-count'],
    queryFn: getOrgUsersCount,
    enabled: user?.subscription?.tier === 'organization',
  });
};
